import React, { useState } from "react";
import { useAppContext } from "providers/AppProvider";
import DataTable from "react-data-table-component";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import IconButton from "components/common/IconButton";
import { Pen, Trash } from "react-bootstrap-icons";
// import {
//   updateDuplicateRow,
//   deleteDuplicateRow,
// } from "../config/practitionerSlice";
import EditEmployeeModal from "./EditEmpolyeeModal";

const EmployeeResultStep = () => {
  const dispatch = useDispatch();
  const { tableData } = useSelector((state) => state.empolyee);

  const {
    config: { theme },
  } = useAppContext();

  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleEditClick = (row) => {
    setSelectedRow(row);
    setShowModal(true);
  };

  const handleDeleteRow = (rowNum) => {
    // dispatch(deleteDuplicateRow(rowNum));
  };

  const columns = [
    { name: "#", selector: (row) => row.rowNum - 1, width: "60px" },
    {
      name: "Name",
      selector: (row) =>
        `${row?.["First Name (English)"] || row.first_name_eng || ""} ${
          row?.["Family Name (English)"] || row.last_name_eng || ""
        }`,
    },
    { name: "Email", selector: (row) => row?.["Email"] || row?.email || "-" },
    {
      name: "National ID",
      selector: (row) => row.national_id || row?.["National Id"] || "-",
    },
    {
      name: "Nationality",
      selector: (row) => row.nationality?.title || row?.["Nationality"] || "-",
    },
    {
      name: "System Privilage",
      selector: (row) =>
        row.system_privilage?.syspri_name || row?.["System Privilage"] || "-",
    },
    {
      name: "Status",
      cell: (row) => {
        if (row.status === "duplicate") {
          return <span className="badge bg-warning">Duplicate</span>;
        }
        return row.isValid ? (
          <span className="badge bg-success">Valid</span>
        ) : (
          <span className="badge bg-danger">Invalid</span>
        );
      },
      width: "100px",
    },
  ];

  return (
    <div>
      {/* {duplicateRows?.length > 0 && (
        <div className="mb-4">
          <h5 className="text-danger mb-3">
            Duplicate Records Found ({duplicateRows.length})
          </h5>
          <DataTable
            columns={columns}
            data={duplicateRows}
            theme={theme}
            highlightOnHover
            dense
          />
        </div>
      )} */}
      <DataTable
        columns={columns}
        data={tableData}
        // pagination
        theme={theme}
        highlightOnHover
        dense
      />
      <EditEmployeeModal
        show={showModal}
        onHide={() => setShowModal(false)}
        rowData={selectedRow}
      />
    </div>
  );
};

export default EmployeeResultStep;
